const CSRF_LOG_PREFIX = '[GET - CSRF]';
const LOG_PREFIX = '[Support API]';
const USER_LOG_PREFIX = '[GET - User]';

const DEFAULT_HEADERS = {
  'Content-type': 'application/json',
};

export { CSRF_LOG_PREFIX, DEFAULT_HEADERS, LOG_PREFIX, USER_LOG_PREFIX };
